<div class="row justify-content-center mt-5">
  <div class="col-12 col-md-8 col-lg-6">
    <div class="card">
      <div class="card-body text-center p-5">

        <!-- Loading State -->
        <div *ngIf="confirmationStatus === 'loading'" class="loading-state">
          <div class="spinner-border text-primary mb-4" role="status" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">Loading...</span>
          </div>
          <h3>Confirming your email...</h3>
          <p class="text-muted">Please wait while we verify your email address.</p>
        </div>

        <!-- Success State -->
        <div *ngIf="confirmationStatus === 'success'" class="success-state">
          <div class="mb-4">
            <i class="bi bi-check-circle-fill text-success" style="font-size: 4rem;"></i>
          </div>
          <h2 class="card-title mb-4">Email Confirmed!</h2>
          <p class="card-text mb-4">{{ message }}</p>
          <div class="alert alert-success" role="alert">
            Your email has been successfully verified. You can now log in to your account.
          </div>
          <button class="btn btn-primary mt-3" (click)="navigateToLogin()">
            Go to Login
          </button>
        </div>

        <!-- Error State -->
        <div *ngIf="confirmationStatus === 'error'" class="error-state">
          <div class="mb-4">
            <i class="bi bi-exclamation-circle-fill text-danger" style="font-size: 4rem;"></i>
          </div>
          <h2 class="card-title mb-4">Confirmation Failed</h2>
          <p class="card-text mb-4">{{ message }}</p>
          <div class="alert alert-danger" role="alert">
            <strong>What to do:</strong> Please check the link in your email or contact support for assistance.
          </div>
          <div class="mt-3">
            <a routerLink="/authentication/login" class="btn btn-outline-primary me-2">Back to Login</a>
            <a routerLink="/" class="btn btn-outline-secondary">Go to Home</a>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
